import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule } from '../material/material.module';
import { LoadingIndicatorComponent } from './loading-indicator/loading-indicator.component';

// NOTE: not used
// Only used in the datatables in error and event logs which themselves are not used right now

@NgModule({
    declarations: [LoadingIndicatorComponent],
    imports: [CommonModule, MaterialModule],
    exports: [LoadingIndicatorComponent]
})
export class LoadingModule {}
